// src/hooks/useIframeComments.js

import { useEffect } from 'react';

export default function useIframeComments(viewMode, iframeRef, setCommentInput) {
  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe || viewMode !== 'comment') return;

    const handleClick = (e) => {
      const rect = iframe.getBoundingClientRect();
      const x = e.clientX - rect.left + (iframe.contentWindow?.scrollX || 0);
      const y = e.clientY - rect.top  + (iframe.contentWindow?.scrollY || 0);
      setCommentInput({ x, y, text: '' });
    };

    const attachListener = () => {
      const doc = iframe.contentWindow?.document;
      if (doc?.body) {
        doc.body.addEventListener('click', handleClick);
      } else {
        setTimeout(attachListener, 100);
      }
    };

    attachListener();
    return () => {
      try {
        iframe.contentWindow?.document.body.removeEventListener('click', handleClick);
      } catch {}
    };
  }, [viewMode, iframeRef, setCommentInput]);
}
